import type { FaireProductEntity } from "../../entity_types/product";

export const p_usv4xb8vw4: FaireProductEntity = {
  token: "p_usv4xb8vw4",
  type: "product",
  name: "First Honey® Manuka Wound Ointment",
  brandToken: "b_j732ad6fru",
  brandName: "First Honey",
  imageUrl:
    "https://cdn.faire.com/fastly/479bc4a33bf2eeb8272b957152dec5ee15b68da7036ad302a4aef0955740f263.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e3fa126890c032f0b85722aa23fccc460808fe7bce101896b62b9d4dac6a692d.jpeg",
    "https://cdn.faire.com/fastly/11b134a9e7dc90ed830acd74b518aa8e98a3ff589714abe2eb1bb056465bf4d9.jpeg",
    "https://cdn.faire.com/fastly/cc692f8f152987b1c60141a3174f012a5d6fd561d1df7da55f26a54bd386ebcc.jpeg",
    "https://cdn.faire.com/fastly/421156783b4bf0ae157ce2b8271d6fed37e5445e299d6af59b65a7998e5176e5.jpeg",
    "https://cdn.faire.com/fastly/02dc099739201473ba0b2c18dece9dcb969d21502fa4130596f1904b5bec1f2d.jpeg",
    "https://cdn.faire.com/fastly/df495f88dbde530c1b7e85169b26958e1c962e69c3e6fdf662981d6986b23db2.jpeg",
    "https://cdn.faire.com/fastly/a0d6e106ec9d6f3e5ad797d816dbd927656edf3b916bd99e4f6fc74b172dab9b.jpeg",
  ],
  priceDollars: 6.91,
  description:
    "Manuka Wound Ointment \n\n\nHealing in a tube - our beloved all natural First Aid ointment.\n\nThis naturally potent skin healing ointment is a great all rounder for any first aid kit, made with active Leptospermum honey (Manuka honey), harvested by our own bees in New Zealand. It has been certified as a medical grade honey for treating cuts and burns.\n\nThis sterile easy-to-apply ointment creates an optimal environment for the healing of minor wounds and provides long-lasting infection protection while working to immediately reduce pain and minimize scarring long-term.\n\n\nProduct details\n\nEasy-to-use, non toxic, natural and 100% safe, our First Honey® Manuka Wound Ointment is one product with three powerful healing actions.",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:24.542Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
